import register from '@kpsys/angularjs-register';
import {KpHeaderService} from 'shared/components/kp-header/kp-header.service';

export default register('portaro.shared.header')
    .service(KpHeaderService.serviceName, KpHeaderService)
    .name();